import { TypedDocumentNode, useQuery } from '@apollo/client';
import { OperationVariables } from '@apollo/client/core';
import { QueryFunctionOptions, QueryResult } from '@apollo/client/react/types/types';
import { DocumentNode } from 'graphql';
import React from 'react';
import Loader from './Loader';

interface QueryResultWithData<TData, TVariables> extends QueryResult<TData, TVariables> {
  data: TData;
}

// extends QueryComponentOptions<TData> but uses QueryResultWithData
interface QueryWithLoaderProps<TData, TVariables> extends QueryFunctionOptions<TData, TVariables> {
  children: (result: QueryResultWithData<TData, TVariables>) => JSX.Element | null;
  query: DocumentNode | TypedDocumentNode<TData, TVariables>;
}

export default function QueryWithLoader<TData, TVariables extends OperationVariables = OperationVariables>(
  props: QueryWithLoaderProps<TData, TVariables>
) {
  const { data, loading, error, ...rest } = useQuery(props.query, {
    ...props
  });

  return (
    <Loader loading={loading} error={error}>
      {data && !loading && !error && props.children({ data, loading, error, ...rest })}
    </Loader>
  );
}
